// extracted by mini-css-extract-plugin
module.exports = {"container":"servicing-sign-in_container__Ldzg9","button":"servicing-sign-in_button__icvXT","text":"servicing-sign-in_text__2j3Qe","line":"servicing-sign-in_line__3edtG"};